class EnvironmentSettings {
  constructor() {
    this.Environment = "LIVE";
    this.LiveUrl = "https://medcoserver.online/api/";
    // this.Environment = "dev";
    //this.LiveUrl = "https://localhost:5001/api/";
  }
}
export default new EnvironmentSettings();
